import {BoxesComponent} from './BoxesComponent';
import Swiper, {Autoplay, Pagination} from 'swiper';

export class ImplementationBoxesComponent extends BoxesComponent {
  containerName = 'implementation-boxes';

  constructor() {
    super();

    this.initialize();

    this.addEventListeners();
  }
}